export function checkStatus(newSubAccountRequest: NewSubAccountRequest) {
  if (!newSubAccountRequest.approved && !newSubAccountRequest.rejectReason && !newSubAccountRequest.usedInvoice) {
    return "Pending Approval";
  } else if (!newSubAccountRequest.approved && !newSubAccountRequest.rejectReason && !newSubAccountRequest.paymentDate && newSubAccountRequest.usedInvoice) {
    return "Cancelled";
  } else if (newSubAccountRequest.approved && !newSubAccountRequest.paymentDate) {
    return "Pending Payment";
  } else if (!newSubAccountRequest.approved && newSubAccountRequest.rejectReason) {
    return "Rejected";
  } else if (newSubAccountRequest.approved && newSubAccountRequest.paymentDate && !newSubAccountRequest.usedInvoice) {
    return "Ready To Use";
  } else if (newSubAccountRequest.approved && newSubAccountRequest.paymentDate && newSubAccountRequest.usedInvoice) {
    return "Used";
  }
}

export interface NewSubAccountRequest {
  id: number;
  merchantId: number;
  count: number;
  justification: number;
  createDate: Date;
  updateDate: Date;

  invoiceNumber: string;
  totalAmount: number;
  totalVatAmount: number;

  paidBy: string;
  paymentDate: Date;

  approved: boolean;
  usedInvoice: boolean;
  rejectReason: string;
  decisionDate: Date;
}
